import React from 'react'

import { cn } from '@/lib/utils.ts'

export const FormActions: React.FC<{
  className?: string
  children?: React.ReactNode
}> = ({ className, children }) => (
  <div
    className={cn(
      className,
      'sticky bottom-0 flex justify-end gap-x-2 border-t bg-white py-4 *:grow *:basis-1 md:*:grow-0 md:*:basis-auto'
    )}
  >
    {children}
  </div>
)
